import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SendcuotasService {

  url = environment.apiURL + 'formas_pago';


  constructor(private http: HttpClient) { }


  sendCuotas(mensaje,name,issuer): Observable<any> {
    const url = this.url+ '/' + mensaje+ '/' + name+ '/' + issuer;
    return this.http.get<any>(url);
  }
}
